import { Component, OnInit } from '@angular/core';
import { adhocDto } from 'src/app/models/adhocDto';
import { approveAddhoc } from 'src/app/models/approveAdhoc';
import { NotificationType } from 'src/app/models/notification.message';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { AdHocService } from 'src/app/services/ad-hoc.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-view-approveadhoc',
  templateUrl: './view-approveadhoc.component.html',
  styleUrls: ['./view-approveadhoc.component.css']
})
export class ViewApproveadhocComponent implements OnInit {

  ViewRequestVisible = false;
  ApproveRequest: adhocDto | any
  RequestApprovals: RequestApprovalDto[] | undefined;
  currentUser: any
  adhocs: adhocDto[] | undefined;

  Comment: string ='';
  

  constructor(private adhocService: AdHocService, private notification: NotificationService,
      private tokenService: TokenService, private requestApprovalService:RequestApprovalsService ) { }

  ngOnInit(): void {
    this.loadRecords();
  }

  async loadRecords() {
      ;
      let resContracts = await this.adhocService.getCurrentUserPendingRequest().toPromise();
      this.adhocs = <adhocDto[]>resContracts.responseData;
      console.log('this is adhocs ', this.adhocs);
  
    }

    async open(data: adhocDto) {
    
        this.ViewRequestVisible = true;
    
        this.ApproveRequest = data;
        let resApprovals = await this.adhocService.getRequestApprovals(data.id).toPromise();
        this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;
    
      }
    
      close(): void {
        this.ViewRequestVisible = false;
      }
    
      cancel(): void {
     return;
      }
     
      confirm(): void {
        alert('click confirm');
      }

       async approveContract() {
          
          const model: approveAddhoc = { id: this.ApproveRequest.id, message: this.Comment  };
      
        console.log('this is the payload', model);
      
            this.adhocService.approveContract(model).subscribe({
              next: (data => {
                
                if (data.responseCode == "00") {
                  this.notification.sendMessage({
                    message: data.message,
                    type: NotificationType.success
                  });
      
                  this.loadRecords();
                  this.close()
                }
                else {
      
                  this.notification.sendMessage({
                    message: data.message,
                    type: NotificationType.error
                  });
      
                }
      
              }),
              error: ((error: any) => {
                console.log(error.error);
                ;
      
      
                this.notification.sendMessage({
                  message: error.error.message,
                  type: NotificationType.error
                });
              })
      
            });
      
        }
      
        async rejectContract() {
      
          if (this.Comment === '') {
            this.notification.sendMessage({
              message: 'Comment is required when rejecting request',
              type: NotificationType.error
            });
          }
          else {
            
      
              this.close();
      
               
        
      
              const model: approveAddhoc = { id: this.ApproveRequest.id, message: this.Comment };
      
              this.adhocService.rejectContract(model).subscribe({
                next: (data => {
      
                  if (data.responseCode == "00") {
                    this.notification.sendMessage({
                      message: data.message,
                      type: NotificationType.success
                    });
      
                    this.loadRecords();
                    this.close();
                  }
                  else {
      
                    this.notification.sendMessage({
                      message: data.message,
                      type: NotificationType.error
                    });
      
                  }
      
                }),
                error: ((error: any) => {
                  console.log(error.error);
                  ;
      
      
                  this.notification.sendMessage({
                    message: error.error.message,
                    type: NotificationType.error
                  });
                })
      
              });
          
          }
        }

}
